module.exports = __webpack_public_path__ + "bradavice_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_3_before_tn.jpg
// module id = 1402
// module chunks = 0